<template>
  <section class="w-full grid grid-cols-2 gap-2 ph-16 mv-16">
    <div v-for="course in courses" :key="course.id">
      <PrakerjaCard :course="course" :course-type="course.courseType" class="course" normal-course />
    </div>
  </section>
</template>

<script>
import PrakerjaCard from '../PrakerjaCard/PrakerjaCard.vue';

export default {
  name: 'PrakerjaCourseList',
  components: {
    PrakerjaCard,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
};
</script>
